import { useEffect, useState } from "react";
import { Spin, Form, Col, Button, Row,message,Space } from 'antd';
import queryString from 'query-string';
import history from "../../history";
import setEbBasvuruOzellik from "../../services/setEbBasvuruOzellik";
import getEbBasvuruOzellikKural from "../../services/getEbBasvuruOzellikKural";
import DynamicFormItem from '../Helpers/DynamicFormItem';
import { isNullOrEmptyOrUndefined } from "../Helpers/Util";


const parsed = queryString.parse(history.location.search);

const formLayout = {
    labelCol : {
        span : 6
    },
    wrapperCol : {
        span : 12
    }
}

const EbBasvuruOzellikForm = () => {

    const [spining, setSpining] = useState(false);
    const [basvuruOzellik, setBasvuruOzellik] = useState([]);
    const [kodOzellikList,setKodOzellikList]= useState([]);
    const [form] = Form.useForm();

    const onLoad = async () => {
        setSpining(true);
        var kodOzelliks = [];
        await getEbBasvuruOzellikKural(parsed).then(resp => {
           
            if(resp.data.success){

                resp.data.result.map(elem => {
                    if(elem.BasvuruOzellik != null){
                        form.setFieldsValue({ [elem.Ozellik.Objectid] : elem.BasvuruOzellik.OzellikDeger });
                    }else{
                        form.setFieldsValue({ [elem.Ozellik.Objectid] : [] });
                    }
                    kodOzelliks.push(elem.Ozellik);
                });
                setBasvuruOzellik(resp.data.result);
                setKodOzellikList(kodOzelliks);
            }else{                
                message.error(resp.data.message);
            }
        }).catch(ex => {
            message.error(String(ex.message));
        })
        setSpining(false);
    }

    useEffect(() => {
        onLoad();
    },[]);

    const getDataFilter= (key,zorunluMu,ozellikDeger) => {
        var data = {
           
            OzellikKodu: key,
            OzellikDeger:  ozellikDeger,
            ZorunluMu : zorunluMu,
            GrupKodu : 1
        };

       

        return data;
    }

    const onFinish = async(e) => {

 
        setSpining(true);
        
        let formValues = form.getFieldValue();  
        let dataFilter = {
            TabloAdi: parsed.TabloAdi,
            KodOzellikList : kodOzellikList,
            EbBasvuruOzellik : []
        };

        if(parsed.TabloAdi == 'basvuru') {
            dataFilter.TabloObjectid = parseInt(parsed.BasvuruId)
        }else if (parsed.TabloAdi == 'basvuru_ana'){
            dataFilter.TabloObjectid = parseInt(parsed.ParentBasvuruId)
        }

        let isError = false;
        let errorMessage = "";

        await Object.keys(formValues).map(key =>{
          
            var zorunluMu = basvuruOzellik.filter(elem => elem.Ozellik.Objectid == key)[0].ZorunluMu;
            var ozellikDeger = Array.isArray(formValues[key]) ? formValues[key] : [formValues[key]];

            if(zorunluMu){                
               if(!isNullOrEmptyOrUndefined(ozellikDeger[0])){
                dataFilter.EbBasvuruOzellik.push(getDataFilter(key,zorunluMu,ozellikDeger));
               }else{
                isError= true;
                errorMessage = "Lütfen zorunlu alan bilgilerini giriniz!";
               }
            }else{
                dataFilter.EbBasvuruOzellik.push( getDataFilter(key,zorunluMu,ozellikDeger));
            }
           
        });
        
        if(isError){
            message.error(errorMessage);
            setSpining(false);
        }else if(dataFilter.EbBasvuruOzellik.length != 0 ){
            await setEbBasvuruOzellik(dataFilter).then(resp => {
            
                if(resp.data.success){
                    message.success('İşlem başarı ile tamamlandı.');               
                    window.parent.location.reload(); 
                }else{     
                           
                    message.error(resp.data.message);
                }
            }).catch(ex => {
                message.error(String(ex.message));
            }).finally(() => {
                setSpining(false);
            });
        }else{
            setSpining(false);
        }       

       
    }

    return(
            <Spin tip={"Veriler Yükleniyor"} spinning={spining} style={{width: '100%', justifyContent: 'center', marginTop : '20%'}} > 
            {basvuruOzellik.length != 0 ? 
                    <Form form={form}  {...formLayout} >
                        <DynamicFormItem name={"dynamicFormItem"} dynamicFormItem = {basvuruOzellik} form={form}></DynamicFormItem>                   
                        <Row>
                            <Col span={18} style={{textAlign: 'right', marginLeft : 10}}>
                                <Button type="primary" onClick={onFinish}>
                                    Kaydet
                                </Button>
                            </Col>  
                        </Row>  
                    </Form>  : 
                <>
                    {!spining && <Space direction="horizontal" style={{width: '100%', justifyContent: 'center', marginTop : '20%', fontWeight:"bold"}}> Özellik Bulunamadı </Space>}
                </>
                }
                
            </Spin>
    );

}

export default EbBasvuruOzellikForm;